import React, { useState } from "react"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from "reactstrap"
import { userInfo } from "utils"
import { useMutation } from "@apollo/react-hooks"
// import customerImage from "../../../../assets/images/avatar/avatar-customer.png"
// import assistantImage from "../../../../assets/images/avatar/avatar-getech.jpg"
import { LOGOUT } from "../../gql"

const ProfileDropdown = ({ history }) => {
  const [isOpen, setIsOpen] = useState(false)
  // const { role, name, email } = userInfo()
  const { name, email } = userInfo()
  // const { CUSTOMER, CUSTOMER_PURCHASER } = userRole
  // const displayImg =
  //   role === CUSTOMER || role === CUSTOMER_PURCHASER
  //     ? customerImage
  //     : assistantImage

  const [logout, { error }] = useMutation(LOGOUT)

  const performLogout = () => {
    localStorage.setItem("token", "")
    history.push("/login")
  }

  if (error) {
    performLogout()
  }

  return (
    <Dropdown nav inNavbar isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle nav caret className="pro-pic">
        <i class="fas fa-user"></i>
      </DropdownToggle>
      <DropdownMenu right className="user-dd">
        <div className="d-flex no-block align-items-center p-3 mb-3 border-bottom">
          <div className="ml-3">
            <h4 className="mb-0">{name}</h4>
            <p className="text-muted mb-0">{email}</p>
            <Button
              color="primary"
              className="text-white border-0 mt-2"
              style={{
                background: "var(--getech-gradient)"
              }}
              onClick={() => {
                history.push("/profile/0")
                setIsOpen(!isOpen)
              }}
            >
              帳號設定
            </Button>
          </div>
        </div>
        <DropdownItem
          onClick={async () => {
            setIsOpen(!isOpen)
            await logout()
            performLogout()
          }}
        >
          <i className="fa fa-power-off mr-1 ml-1" /> 登出
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}

export default ProfileDropdown
